<script>
  import atendimentoServico from '~modulos/atendimento/servico';
  import projetoServico from '~modulos/projeto/servico';

  import { modal } from 'vue-strap';
  import FileInput from '~componentes/InputFile.vue';

  export default {
    components: { modal, FileInput },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        atendimento: {
          fundacao: '',
          nome: '',
          telefone: '',
          celular: '',
          motivo: '',
          codigoProjeto: '',
          email: '',
          area: '',
          mensagem: '',
          arquivo: '',
        },
        listaMotivoContato: [
          'Dúvida/informação',
          'Sugestão',
          'Elogio',
          'Reclamação',
          'Outros',
        ],
        listaAreaAtendimento: [],
        listaAnalistasAtendimento: [],
        exibirAnalistaAtendimento: false,
        mensagemAberturaAtendimento: '',
        exibirMensagemAberturaAtendimento: false,
        projetos: [],
        usuario: this.$storage.usuario(),
        configuracao: this.$storage.configuracao(),
        urlBaseAtendimentoFau: this.$storage.configuracao().urlBaseAtendimentoFau,
      }
    },
    methods: {
      fecharModalAtendimento() {
        this.isAtendimento = false;
      },
      mostrarConfirmacaoAberturaAtendimento(retornoAberturaAtendimento) {
        if ('number' in retornoAberturaAtendimento && retornoAberturaAtendimento.number) {
          this.mensagemAberturaAtendimento =  `${retornoAberturaAtendimento.number}`;
          this.exibirMensagemAberturaAtendimento = true;
        } else {
          this.mensagemAberturaAtendimento = '';
          this.exibirMensagemAberturaAtendimento = false;
        }
      },
      validarModalAtendimento() {
        this.$validator
          .validateAll()
          .then(async (valido) => {
            if (valido) {
              const retornoAberturaAtendimento = await atendimentoServico.enviar(this.urlBaseAtendimentoFau, this.atendimento);
              this.mostrarConfirmacaoAberturaAtendimento(retornoAberturaAtendimento);
            } else {
              throw new Error('validacao')
            }
          })
      },
      async listaDeProjetos() {
        return projetoServico
          .listaProjetosAtendimento()
          .then(projetos => {
            this.projetos = projetos;
          })
      },
      async listaDeAnalistasGrupo() {
        if (this.atendimento.area && (this.atendimento.area === 5 || this.atendimento.area === 6)) {
          this.listaAnalistasAtendimento = await atendimentoServico
            .analistas(this.urlBaseAtendimentoFau, this.atendimento.area);
          this.exibirAnalistaAtendimento = true;
        } else {
          this.listaAnalistasAtendimento = [];
          this.exibirAnalistaAtendimento = false;
        }
      },
      nomeAnalistaAtendimento(analista) {
        return `${analista.firstname} ${analista.lastname} - ${analista.department}`;
      },
      async carregaAtendimentos() {
        const gruposAtendimento = await atendimentoServico.grupos(this.urlBaseAtendimentoFau);
          this.listaAreaAtendimento = gruposAtendimento.filter((grupo) => grupo.active && grupo.frontfau);
          await this.listaDeProjetos();
      }
    },
    computed: {
      showModalAtendimento() {
        this.atendimento = {
          fundacao: this.configuracao.abreviaturaFundacao.toUpperCase(),
          nome: '',
          telefone: '',
          celular: '',
          motivo: '',
          codigoProjeto: '',
          email: '',
          area: '',
          mensagem: ''
        };
        this.exibirAnalistaAtendimento = false;
        this.mensagemAberturaAtendimento = '';
        this.exibirMensagemAberturaAtendimento = false;

        return this.mostrar;
      },
    },
  }
</script>

<style>
  .mensagem-atendimento {
    background-color: rgba(60, 179, 113, 0.3);
    border: 2px solid #006400;
    border-radius: 10px;
    padding: 15px;
    color: #006400;
  }
</style>

<template>
  <div>
    <modal ref="modalAtendimento"
           name="modalAtendimento"
           :value="showModalAtendimento"
           :width="'80%'"
           :large=true

           :backdrop="false"
           @closed="$emit('fechado')">

      <div slot="modal-header" class="modal-header">
        <h2><b>CENTRAL DE ATENDIMENTO {{ this.configuracao.abreviaturaFundacao.toUpperCase() }}</b></h2>
        <br/>
        <p>Este é o canal da {{ this.configuracao.abreviaturaFundacao.toUpperCase() }} com os seus usuários. Por aqui você poderá fazer suas consultas, tirar dúvidas, encaminhar elogios, sugestões e reclamações.</p>
      </div>

      <div class="row" v-if="!exibirMensagemAberturaAtendimento">
        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('nomeAtendimento')}">
            <label class="control-label" for="nome">Seu nome</label>
            <input type="text"
                   class="form-control"
                   id="nomeAtendimento"
                   maxlength="100"
                   v-model="atendimento.nome"
                   placeholder="Nome Completo"
                   data-vv-name="nomeAtendimento"
                   data-vv-as="nome"
                   v-validate="'required'">
            <p class="text-danger" v-show="errors.has('nomeAtendimento')">{{ errors.first('nomeAtendimento') }}</p>
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group">
            <label class="control-label" for="telefone">Seu telefone</label>
            <input type="text"
                   class="form-control"
                   id="telefoneAtendimento"
                   v-mascara="'telefone'"
                   v-model="atendimento.telefone"
                   placeholder="(99) 9999-9999">
          </div>
        </div>

        <div class="col-lg-2">
          <div class="form-group">
            <label class="control-label" for="celular">Seu celular</label>
            <input type="text"
                   class="form-control"
                   id="celularAtendimento"
                   v-mascara="'telefone'"
                   v-model="atendimento.celular"
                   placeholder="(99) 99999-9999">
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('motivoAtendimento')}">
            <label class="control-label" for="motivoAtendimento">Motivo do contato</label>
            <select id="motivoAtendimento"
                    class="form-control"
                    v-model="atendimento.motivo"
                    data-vv-as="motivo do contato"
                    data-vv-name="motivoAtendimento"
                    v-validate="'required'">
              <option value="">Selecione...</option>
              <option :value="motivoContato" v-for="motivoContato in listaMotivoContato">{{ motivoContato }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('motivoAtendimento')">{{ errors.first('motivoAtendimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row" v-if="!exibirMensagemAberturaAtendimento">
        <div class="col-lg-4">
          <div class="form-group">
            <label class="control-label" for="codigoProjetoAtendimento">Código do projeto</label>
            <select id="codigoProjetoAtendimento"
                    class="form-control"
                    v-model="atendimento.codigoProjeto">
              <option value="">Selecione...</option>
              <option :value="projeto.codigoProjetoSimples" v-for="projeto in projetos">{{ projeto.nomeProjeto }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('codigoProjetoAtendimento')">{{ errors.first('codigoProjetoAtendimento') }}</p>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('emailAtendimento')}">
            <label class="control-label" for="emailAtendimento">E-mail</label>
            <input type="text"
                   class="form-control"
                   id="emailAtendimento"
                   v-model="atendimento.email"
                   placeholder="seu.email@email.com.br"
                   data-vv-as="e-mail"
                   data-vv-name="emailAtendimento"
                   v-validate="'required|email'"
                   maxlength="100">

            <p class="text-danger" v-show="errors.has('emailAtendimento')">{{ errors.first('emailAtendimento') }}</p>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="form-group required" :class="{'has-error': errors.has('areaAtendimento')}">
            <label class="control-label" for="areaAtendimento">Área</label>
            <select id="areaAtendimento"
                    class="form-control"
                    v-model="atendimento.area"
                    data-vv-as="area"
                    data-vv-name="areaAtendimento"
                    @change="listaDeAnalistasGrupo"
                    v-validate="'required'">
              <option value="">Selecione...</option>
              <option :value="grupoAtendimento.id" v-for="grupoAtendimento in listaAreaAtendimento">{{ grupoAtendimento.name }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('areaAtendimento')">{{ errors.first('areaAtendimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row" v-if="!exibirMensagemAberturaAtendimento">
        <div class="col-lg-8">
          <div class="form-group" :class="{'has-error': errors.has('arquivoAtendimento')}">
            <label class="control-label" for="arquivoAtendimento">Arquivo (Limite de 5Mb)</label>
            <file-input id="arquivoAtendimento"
                        v-model="atendimento.arquivo"
                        data-vv-as="arquivo"
                        data-vv-name="arquivoAtendimento"
                        v-validate=""></file-input>
            <p class="text-danger" v-show="errors.has('arquivoAtendimento')">{{ errors.first('arquivoAtendimento') }}</p>
          </div>
        </div>

        <div class="col-lg-4" v-if="exibirAnalistaAtendimento">
          <div class="form-group" :class="{'has-error': errors.has('analistaAtendimento')}">
            <label class="control-label" for="analistaAtendimento">Analista</label>
            <select id="analistaAtendimento"
                    class="form-control"
                    v-model="atendimento.analista"
                    data-vv-as="analista"
                    data-vv-name="analistaAtendimento"
                    v-validate="">
              <option value="">Sem analista</option>
              <option :value="analistasAtendimento.id" v-for="analistasAtendimento in listaAnalistasAtendimento">{{ nomeAnalistaAtendimento(analistasAtendimento) }}</option>
            </select>

            <p class="text-danger" v-show="errors.has('areaAtendimento')">{{ errors.first('analistaAtendimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row" v-if="!exibirMensagemAberturaAtendimento">
        <div class="col-lg-12">
          <div class="form-group required" :class="{'has-error': errors.has('mensagemAtendimento')}">
            <label class="control-label" for="mensagemAtendimento">Mensagem</label>
            <textarea class="form-control"
                      id="mensagemAtendimento"
                      v-model="atendimento.mensagem"
                      data-vv-name="mensagemAtendimento"
                      data-vv-as="mensagem"
                      maxlength="500"
                      v-validate="'required|minimo10'">
          </textarea>
            <p class="text-danger" v-show="errors.has('mensagemAtendimento')">{{ errors.first('mensagemAtendimento') }}</p>
          </div>
        </div>
      </div>

      <div class="row mensagem-atendimento" v-if="exibirMensagemAberturaAtendimento">
        <div class="col-lg-12">
          <h3>Olá, mensagem recebida!</h3>
          <h3>A sua solicitação já está em análise e será brevemente respondida.</h3>
          <h3>Anote o número de seu atendimento:&nbsp;<b>{{ mensagemAberturaAtendimento }}</b></h3>
        </div>
      </div>

      <div slot="modal-footer" class="modal-footer">
        <button type="button" class="btn btn-primary" @click="validarModalAtendimento" v-if="!exibirMensagemAberturaAtendimento">
          <i class="fa fa-check"></i> ENVIAR MENSAGEM
        </button>
        <button type="button" class="btn btn-default" @click="$refs.modalAtendimento.action(false, 1)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalAtendimento.vue